import $ from 'jquery';

const bookNowEl = '.book-now';
const crisisMessageButton = '.crisis-message__open';
/**
 * logo inverse section
 * Add section class to the list "logoInverseSections" and logo will be white-colored
 * on background of this particular section
 * @type {*[]}
 */
const logoInverseSections = [
  '.hero',
];

const footerSections = [
  '.footer',
  '.footer-top',
];

const distanceToEffect = 50;

// eslint-disable-next-line func-names
const checkFooterOverlap = function (element, sections) {
  let overlaps = false;
  const intersectionOffset = 30;

  $(element).each((i, el) => {
    const $el = $(el);
    const elHeight = $el.outerHeight();
    const elTop = $el.offset().top;
    const elBottom = elTop + elHeight;

    sections.forEach((section) => {
      // eslint-disable-next-line no-undef
      if (isElementExists(section)) {
        $(section).each(function () {
          const $sec = $(this);
          const secTop = $sec.offset().top;
          const secHeight = $sec.outerHeight();
          const secBottom = secTop + secHeight;

          if (elBottom > (secTop + intersectionOffset) && elTop < secBottom) {
            overlaps = true;
          }
        });
      }
    });

    if (overlaps) {
      $(el).addClass('footer-inverse');
    } else {
      $(el).removeClass('footer-inverse');
    }
  });
};

$(window).bind('load scroll resize', () => {
  // eslint-disable-next-line no-undef
  elemColorByWindowScroll(bookNowEl, logoInverseSections);
  checkFooterOverlap(bookNowEl, footerSections);

  $(bookNowEl).addClass('opaque');
  $(crisisMessageButton).addClass('opaque');
  if ($(window).scrollTop() < distanceToEffect || !$(bookNowEl).hasClass('brand')) {
    $(bookNowEl).removeClass('opaque');
    $(crisisMessageButton).removeClass('opaque');
  }
});
